var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list)?_c('div',{class:{'related-items': true, 'related-items--no-spacing': !_vm.topSpacing}},[_vm._t("default"),_c('List',_vm._l((_vm.list),function(item,index){return _c('Item',{key:_vm.post_id + '-' +item.id + '-' + index,attrs:{"item":item}})}),1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }